import { textToneClass, type ChipTone } from './tokens'

const clampRatio = (value: number): number => {
  if (!Number.isFinite(value)) return 0
  return Math.min(1, Math.max(0, value))
}

export const DeadlineToken = ({
  label,
  remaining,
  tone = 'danger',
}: {
  label: string
  remaining?: number | undefined
  tone?: ChipTone
}) => (
  <span className={`deadline ${textToneClass(tone)}`}>
    {remaining === undefined ? null : (
      <span className="deadline-track" aria-hidden="true">
        <span className="deadline-fill" style={{ inlineSize: `${clampRatio(remaining) * 100}%` }} />
      </span>
    )}
    <span className="deadline-label num">{label}</span>
  </span>
)
